import { FormattedMessage, useIntl } from 'react-intl';
import { Card } from 'ui-components/components/card';
import { Text, TextType } from 'ui-components/components/text';
import { messages } from './messages';
import { PickListCheckboxSetting } from './printed-section-settings/pick-list-checkbox-setting';
import { PickListDropdownSetting } from './printed-section-settings/pick-list-dropdown-setting';
import { CHECKBOX_SETTINGS, DROPDOWN_SETTINGS } from './constants';
import style from './style.module.less';

export const PrintedSection = ({ onChange, values }) => {
  const intl = useIntl();

  const updateSetting = (settingName, value) => {
    onChange(settingName, value);
  };

  return (
    <Card className={style['printed-section']}>
      <Text textType={TextType.H4} value={<FormattedMessage {...messages.printedPickListsTitle} />} />
      <div>
        {DROPDOWN_SETTINGS.map(({ settingKey, titleMessage, descriptionMessage, items }) => (
          <PickListDropdownSetting
            key={settingKey}
            descriptionMessage={descriptionMessage}
            items={items.map((item) => ({
              key: item.key,
              name: intl.formatMessage(item.messageKey),
            }))}
            onChange={(value) => updateSetting(settingKey, value)}
            titleMessage={titleMessage}
            value={values[settingKey]}
          />
        ))}
        {CHECKBOX_SETTINGS.map(({ settingKey, checkboxId, titleMessage, descriptionMessage }) => (
          <PickListCheckboxSetting
            key={checkboxId}
            checkboxId={checkboxId}
            checked={values[settingKey]}
            descriptionMessage={descriptionMessage}
            onChange={(value) => updateSetting(settingKey, value)}
            titleMessage={titleMessage}
          />
        ))}
      </div>
    </Card>
  );
};
